import { setLogger } from '../core';
import { logger } from './logger';
setLogger(logger);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-query/es/react/setLogger.js
// module id = 1531
// module chunks = 0